import TabButton from "./TabButton.vue";

export default TabButton;